/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_GOOGLE_AUTH_STATUS = 'SET_GOOGLE_AUTH_STATUS';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';
export const ADMIN_NAME = 'ADMIN_NAME';
export const GRANTS = 'GRANTS';

/* GENERAL */
export const ADD_GENERAL_INFO = 'ADD_GENERAL_INFO';
export const ADD_USERS_INFO = 'ADD_USERS_INFO';

/* APP */
export const ADD_STATISTICS = 'ADD_STATISTICS';
export const ADD_FINANCIAL_GROUPS = 'ADD_FINANCIAL_GROUPS';
export const ADD_KYC_ITEMS = 'ADD_KYC_ITEMS';
export const ADD_GROUP_MESSAGE_SETTINGS = 'ADD_GROUP_MESSAGE_SETTINGS';
export const ADD_GIFT_CARD_SETTINGS = 'ADD_GIFT_CARD_SETTINGS';
export const ADD_NETWORKS = 'ADD_NETWORKS';

export * from './menu/actions';
export * from './settings/actions';
export * from './authUser/actions';
export * from './general/actions';
